import manifest from 'virtual:components-manifest';
import { componentLibrary } from '../../store/componentLibrary';

async function importDynamicComponent(componentName: string) {
  const aliasedComponentName = componentName;
  const componentType = manifest[aliasedComponentName];

  if (!componentType) {
    // TODO - Dynamically import, and render a MissingComponent for non-prod
    throw new Error(`Component not found: ${aliasedComponentName}`);
  }

  const [type, subtype] = componentType.split('/');
  if (subtype === 'legacy') {
    return import(`../../components/contentful/${type}/legacy/${componentName}/${componentName}.svelte`);
  } else {
    return import(`../../components/contentful/${type}/${componentName}/${componentName}.svelte`);
  }
}

export async function loadDynamicBundlesToComponentLibStore(bundles: string[]) {
  // Kick-off dynamic imports
  const importPromises = bundles.map((name) => importDynamicComponent(name));

  // Await the imports and add imported files to component library store.
  const componentModules = await Promise.all(importPromises);

  bundles.forEach((type, i) => componentLibrary.add(type, componentModules[i].default));
}
